<template>
    <rkm-row>
        <rkm-col cols="12">

            <rkm-row>
                <rkm-col cols="12">
                    <BoxAtendimento :item="item" />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="12">
                    <BoxExame :item="item" />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="12">
                    <BoxMedicamento :item="item" />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="12">
                    <BoxReavaliacao :item="item" />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="12">
                    <BoxAlta :item="item" />
                </rkm-col>
            </rkm-row>
        </rkm-col>
    </rkm-row>
</template>

<script>
// Components.
import BoxMedicamento from './components/medicamento/Index'
import BoxAtendimento from './components/atendimento/Index'
import BoxExame from './components/exame/Index'
import BoxAlta from './components/alta/Index'
import BoxReavaliacao from './components/reavaliacao/Index'

export default {
    components: {
        BoxMedicamento,
        BoxAtendimento,
        BoxExame,
        BoxAlta,
        BoxReavaliacao
    },
    props: {
        item: {type: Object, required: true},
    },
}
</script>